var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpnlocker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    fill: "#0500FF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7381 12.6667V11.3333C18.7381 9.46667 17.2714 8 15.4047 8C13.5381 8 12.0714 9.46667 12.0714 11.3333V12.6667C10.9381 12.6667 10.0714 13.5333 10.0714 14.6667V19.3333C10.0714 20.4667 10.9381 21.3333 12.0714 21.3333H18.7381C19.8714 21.3333 20.7381 20.4667 20.7381 19.3333V14.6667C20.7381 13.5333 19.8714 12.6667 18.7381 12.6667ZM13.4047 11.3333C13.4047 10.2 14.2714 9.33333 15.4047 9.33333C16.5381 9.33333 17.4047 10.2 17.4047 11.3333V12.6667H13.4047V11.3333ZM16.1381 17L16.0714 17.0667V18C16.0714 18.4 15.8047 18.6667 15.4047 18.6667C15.0047 18.6667 14.7381 18.4 14.7381 18V17.0667C14.3381 16.6667 14.2714 16.0667 14.6714 15.6667C15.0714 15.2667 15.6714 15.2 16.0714 15.6C16.4714 15.9333 16.5381 16.6 16.1381 17Z",
    fill: "#0A00FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpnlocker);
export default __webpack_public_path__ + "static/media/opnlocker.8c8438482d18734d33cb18d933727ef9.svg";
export { ForwardRef as ReactComponent };